// Shared display helpers for the Assets module pages
export const formatDate = (value) => {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

// Value shown for date inputs, which require yyyy-MM-dd
export const toDateInputValue = (value) => {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toISOString().split('T')[0]
}

export const formatAmount = (value, currency = 'INR') => {
  const amount = Number(value || 0)
  return `${currency} ${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

// Status badges reuse the shared active/inactive/pending styling
export const statusBadgeClass = (status) => {
  const normalized = (status || '').toLowerCase()
  if (['active', 'received', 'assigned', 'completed', 'approved'].includes(normalized)) return 'active'
  if (['cancelled', 'inactive', 'lost'].includes(normalized)) return 'inactive'
  return 'pending'
}
